import React from "react";
import * as echarts from "echarts/lib/echarts";

let myChart = null;
class Charts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        id={this.props.id}
        style={{ width: "100%", height: this.props.height }}
      ></div>
    );
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    myChart = !myChart
      ? echarts.init(document.getElementById(this.props.id))
      : myChart;
    const option = nextProps.chartData;
    myChart.setOption(option);
    window.addEventListener("resize", this.resizeFn);
  }

  resizeFn() {
    myChart.resize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeFn);
    myChart = null;
  }
}

export default Charts;
